import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation.js';
import {amountWithPrecisionAsRequired} from 'javascripts/utils/numberFormatter';
import {observer} from 'mobx-react';

@observer
class DonateFormHeader extends React.Component {
  handleEditAmountClick = () => {
    if (!store.donateForm.disableEditAmount) {
      store.donateForm.step = 'amount';
      store.donateForm.creditCardStep = 1;
    }
  }

  amountStepHeader = () => {
    if(this.props.amountStepHeader) return this.props.amountStepHeader;

    const verb = this.props.showAmountInput ? 'enter' : 'choose';

    return `${t(`views.donate.form.system_campaign.base.${verb}_amount`)} ${store.donateForm.isSubscription ? t('views.donate_form.per_month') : ''}`;
  }

  paymentStepHeader = () => {
    if(this.props.paymentStepHeader) return this.props.paymentStepHeader;

    return `${t('views.donate_form.giving')} ${store.donateForm.currencyUnit}${amountWithPrecisionAsRequired(store.donateForm.amount)}${store.donateForm.isSubscription ? ` ${t('views.donate_form.per_month')}` : ''}`;
  }

  render () {
    const {
      isValidEmail,
      step,
    } = store.donateForm;

    return (
      <span className='adf-form-header text-center'>
        {step === 'amount' &&
          <span dangerouslySetInnerHTML={{__html: this.amountStepHeader()}} />
        }
        {step !== 'amount' && isValidEmail &&
          <span className='header-step-payment'>
            <span>
              <span dangerouslySetInnerHTML={{__html: this.paymentStepHeader()}} />

              {!this.props.skipAmountStep &&
                <a
                  className={cx('edit-amount p40', {'text-grey-40': store.donateForm.disableEditAmount})}
                  dangerouslySetInnerHTML={{__html: `(${t('views.donate_form.edit_amount')})`}}
                  onClick={this.handleEditAmountClick}
                />
              }
            </span>
          </span>
        }
        {step === 'payment' && !isValidEmail &&
          <span className='header-step-payment'>
            {t('views.donate_form.error')}
          </span>
        }
      </span>
    );
  }
}

export default DonateFormHeader;
